const selectors = {
  keyboard: '[data-whatintent=keyboard]',
} as const

export type ThemeSelectors = typeof selectors

export default selectors
